import React, {useState, useEffect} from 'react'
import {useNodes} from '../XTextWrapper/NodeContext'
import {Surface3Wrapper} from '../Surface3Wrapper'
import {CollationTable} from '../CollationTable/CollationTable'
import {TextCompareWrapper} from '../TextCompareWrapper/TextCompareWrapper'
import {CATviewCompare} from '../CATviewCompare/CATviewCompare'
// import {NgramSimilarities} from '../NgramSimilarities'
import { ConvolutionMatches } from '../ConvolutionMatches/ConvolutionMatches'
import { CATviewNgrams } from '../CATviewNgrams/CATviewNgrams'
import { availableTabs, getAvailableComponents, getAvailableTabs} from './WindowUtil'
import { WindowNavBar } from '../WindowNavBar/WindowNavBar'
import { Citation } from '../Citation/Citation'
import { CitationTableWrapper } from '../CitationTableWrapper/CitationTableWrapper'
import { XmlView } from '../XmlView/XmlView'
import { TextOutlineWrapper } from '../TextOutlineWrapper/TextOutlineWrapper'
import { Search3 } from '../Search3/Search3'
import { ResourceNav } from '../ResourceNav/ResourceNav'
import { TextView} from '../TextView/TextView'
import { NodeCommunities } from '../NodeCommunities/NodeCommunities'
import { ManifestationsList } from '../ManifestationsList/ManifestationsList'
import { Comments } from '../Comments/Comments'
import { Chat } from '../Chat/Chat'
import { ResourceHistory} from '../ResourceHistory/ResourceHistory'
import { PersonInfo} from '../PersonInfo/PersonInfo'
import { CodexToc} from '../CodexToc/CodexToc'
import { e } from 'mathjs'
import { CodexInfo } from '../CodexInfo/CodexInfo'
import { Dictionary } from '../Dictionary/Dictionary'


export interface MyComponentProps {
  windowLoad: string
  windowId: string
  handleChangeWindow: any
  openWidthHeight: string // min, middle, max
  handleChangeWindowSize: any
  handleChangeWindowOpenClose: any
  handleChangeView?: any
  view?: string
  handleSetVariantIndexList?: any
  handleUpdateCompareExpressionIds?: any
  collationCompareExpressionIds?: string[]
  rHistory?: string[]
  excludeList?: string[] // list of components to exclude from the window tab
  dictionaryWord?: string // word to pass to dictionary component
}

export const Window: React.FC<MyComponentProps> = (props) => {
  const [windowLoad, setWindowLoad] = useState<string>(props.windowLoad || "citation")
  const {info, secondaryInfo, handleChangeInfo, handleChangeSecondaryInfo, handleChangePreviewInfo, previewInfo} = useNodes();
  

  useEffect(() => {
    if (!!props.windowLoad){
      setWindowLoad(props.windowLoad)
    }
  }, [props.windowLoad])
  
  // I want the parent to be able to control the windowload state
  // but if no function is passed down I want the component to be able to manage the windowload state
  const handleChangeWindowLoad = (windowLoad: string) => {
    if (props.handleChangeWindow){
      props.handleChangeWindow(props.windowId, windowLoad)
    }
    else {
      setWindowLoad(windowLoad)
    }
  }
  const info2: any = {
    resourceid: info?.focusInfo?.expressionid,
    ctranscription: info?.focusInfo?.transcriptionid,
    structureType: info?.focusInfo?.structureType,
    level: info?.focusInfo?.level,
  }
  const tresourceid = info?.focusInfo?.transcriptionid
  const secondaryTresourceid = secondaryInfo?.focusInfo?.transcriptionid
  const eresourceid = info?.focusInfo?.expressionid || info?.resourceid
  const wordRange = info?.focusInfo?.wordRange
  const wordRangeString = wordRange ? "@" + wordRange.start + "-" + wordRange.end : ""
  const selectionRange = {wordRange: wordRange, text: ""}
  const mtFocus = info?.focusInfo?.mtFocus || ""
  const topLevel = info?.topLevelInfo?.expressionid
  const displayType = info?.focusInfo?.structureType || info?.displayType
  console.log("displayType from Window", displayType)
  const previewTresourceId = previewInfo?.focusInfo?.transcriptionid

  const handleChangeInfoPreview = (newId: string) => {
    handleChangePreviewInfo(tresourceid)
    handleChangeInfo(newId)
  }

  const displayCitation = () => {
    if (displayComponents.includes("citation") && windowLoad === "citation"){
      if (displayType === "person"){
        return <PersonInfo resourceid={info?.resourceid} handleChangeInfo={handleChangeInfo}/>
      }
      else if (displayType === "workGroup"){
        return (
            <div>
              <h1>WorkGroupInfo</h1>
            </div>
          );
      }
      else if (displayType === "codex" || displayType === "surface" || displayType === "canvas" || displayType === "manifest"){
        return (
            <CodexInfo resourceid={eresourceid} codexResourceType={displayType}/>
          );
      }
      else{
        return (
        <>
          <Citation tresourceid={tresourceid} selectionRange={selectionRange}/>
          <ManifestationsList eresourceid={eresourceid} tresourceid={tresourceid} secondaryTresourceid={secondaryTresourceid} handleChangeInfo={handleChangeInfo} handleChangeSecondaryInfo={handleChangeSecondaryInfo}/>
        </>
        )
      }
    }
  }

  
  const displayComponents = getAvailableComponents(displayType, props?.excludeList || [])
  const displayTabs = getAvailableTabs(availableTabs, displayComponents)
  return (
    <div className="window-inner-wrapper">
        <WindowNavBar availableTabs={displayTabs}
        handleTabChange={handleChangeWindowLoad} 
        windowLoad={windowLoad} 
        windowId={props.windowId} 
        openWidthHeight={props.openWidthHeight} 
        handleClose={() => {props.handleChangeWindowOpenClose(props.windowId, false)}} 
        handleMinimize={() => {props.handleChangeWindowSize(props.windowId, "min")}} 
        handleMaximize={() => {props.handleChangeWindowSize(props.windowId, "max")}} 
        handleMiddlize={() => {props.handleChangeWindowSize(props.windowId, "middle")}} 
        handleDuplicateWindow={() => {props.handleChangeWindowOpenClose(props.windowId === "window1" ? "window2" : "window1", true)}}
        windowType="text" altWindowState={false}/>
        {props.openWidthHeight !== "min" && 
            <>
            <ResourceNav resourceid={wordRangeString ? eresourceid + wordRangeString : eresourceid} mtFocus={mtFocus} handleChangeInfo={handleChangeInfo} handleChangeView={props.handleChangeView} view={props.view} displayType={displayType}/>
          {/* THis is a window
          the focused id is {info.focusId}

          <button onClick={() => {handleChangeInfo({...info, focusId: "l1-shoatd", focusStructureType: "block"})}}>Change Focus Id to l1-shoatd</button> */}
          {windowLoad === "preview" && 
          <div style={{"width": "60%", "margin": "25px auto"}}>
            <TextView tresourceid={previewTresourceId} start={previewInfo?.focusInfo?.wordRange?.start} stop={previewInfo?.focusInfo?.wordRange?.end} handleChangeInfo={handleChangeInfoPreview}/>

          </div>}

          {(windowLoad === "dictionary" && props.dictionaryWord) && <Dictionary text={props.dictionaryWord} />}

          
          {/* this is the way to only load comments when selected */}
          {windowLoad === "comments" &&<Comments resourceid={tresourceid || eresourceid} expressionid={eresourceid} handleOnClickComment={handleChangeInfo}/>}
          {/* this is the way to always load comments{
            (tresourceid || eresourceid) && <div style={windowLoad !== "comments" ? {"display": "none"} : {}}>
              <Comments resourceid={tresourceid || eresourceid} expressionid={eresourceid} handleOnClickComment={handleChangeInfo}/>
            </div>
          } */}
          
          {windowLoad === "search" && <Search3 searchEid={topLevel} handleChangeInfo={handleChangeInfo}/>}
          {displayCitation()}
          {/* {windowLoad === "citation" && } */}
          {(displayComponents.includes("xml") && windowLoad === "xml") && <XmlView tresourceid={tresourceid}/>}
          {(displayComponents.includes("textOutlineWrapper") && windowLoad === "textOutlineWrapper") && <TextOutlineWrapper focusResourceid={eresourceid} resourceid={topLevel} showFirstLevelChildren={true} handleChangeInfo={handleChangeInfo}/>}
          {(displayComponents.includes("codexToc") && windowLoad === "codexToc") && <CodexToc resourceid={eresourceid} handleChangeInfo={handleChangeInfo} codexResourceType={displayType}/>}
          {windowLoad === "resourceHistory" && <ResourceHistory rHistory={props?.rHistory || []} handleChangeInfo={handleChangeInfo}/>}
          
          {/* TODO need better handling of when window components should be added depending on displayType */}
          {(displayComponents.includes("textCompare") && windowLoad === "textCompare") && <TextCompareWrapper info={info2} handleChangeInfo={handleChangeInfo} selectionRange={selectionRange} handleUpdateCompareExpressionIds={props.handleUpdateCompareExpressionIds}/>}
          {(displayComponents.includes("chat")  && windowLoad === "chat") && <Chat tresourceid={tresourceid} handleChangeInfo={handleChangeInfo}/> }
          {(displayComponents.includes("NgramCompare") && windowLoad === "NgramCompare") && <CATviewNgrams expressionid={eresourceid}/> }
          {/* convolution moved to sub menu within TextCompareWrapper
          {windowLoad === "convolution" && (displayType === "item" || displayType === "collection") && <ConvolutionMatches expressionid={eresourceid?.split("/resource/")[1]} displayType='count'/>} */}
          {(displayComponents.includes("witCompare") && windowLoad === "witCompare") && <CATviewCompare expressionid={eresourceid}/>}
          
          {(displayComponents.includes("citationTable")
            && windowLoad === "citationTable" 
            && (displayType === "item" || displayType === "collection" || displayType === "division")) && 
          <div>
            <p>Source Links</p>
          <CitationTableWrapper 
            autoQuery={true}
            showQueryMenu={false}
            resourceid={eresourceid}
            startLevel={parseInt(info.focusInfo.level) + 1}
            sourceResourceid="http://scta.info/resource/scta"
            xValueType="WorkGroup"
            sourceLevel={1}/>
            <p>Back Links</p>
            <CitationTableWrapper 
            autoQuery={true}
            showQueryMenu={false}
            resourceid="http://scta.info/resource/scta"
            startLevel={1}
            sourceResourceid={eresourceid}
            yValueType="WorkGroup"
            sourceLevel={parseInt(info.focusInfo.level) + 1}/>
            </div>
          }

          {(displayComponents.includes("citationTable") 
            && windowLoad === "citationTable" 
            && displayType === "workGroup") && 
          <div>
            <p>Source Links</p>
          <CitationTableWrapper 
            autoQuery={true}
            showQueryMenu={false}
            resourceid={eresourceid}
            startLevel={1}
            sourceResourceid="http://scta.info/resource/scta"
            xValueType="WorkGroup"
            yValueType="WorkGroup"
            sourceLevel={1}/>
            <p>Back Links</p>
            <CitationTableWrapper 
            autoQuery={true}
            showQueryMenu={false}
            resourceid="http://scta.info/resource/scta"
            startLevel={1}
            sourceResourceid={eresourceid}
            xValueType="WorkGroup"
            yValueType="WorkGroup"
            sourceLevel={1}/>
            </div>
          }
          
          

          { displayComponents.includes("surface3") 
          &&
          <>
            {
              // this loading always now and hiding when not selected
              // follow same pattern for compoenents we want pre-loaded and to retain state when we navigate away like comments and search
            <div style={windowLoad !== "surface3" ? {"display": "none"} : {}}>
              <Surface3Wrapper expressionid={eresourceid} startWord={wordRange?.start} endWord={wordRange?.end} width={props.windowId === "window2" ? 1000 : 500}/>
            </div>
            }
            {windowLoad === "collationTable" && <CollationTable 
            expressionid={eresourceid?.split("@")[0]} manifestationid={info.focusInfo?.manifestationid}
            // this crazy line below adds the eresourceid to the list of expressionIds in case it is not already there, 
            // it then converts to set to remove duplicates (in case the eresource was already there) and then back to array
            expressionIds={props.collationCompareExpressionIds && props.collationCompareExpressionIds.length > 0 ? [...new Set([...props.collationCompareExpressionIds, eresourceid?.split("@")[0]])] : [eresourceid?.split("@")[0]]} 
            wordRange={eresourceid?.split("@")[1]} handleOnSegDoubleClick={handleChangeInfo} 
            handleSetVariantIndexList={props.handleSetVariantIndexList}
            />}
            {/* {windowLoad === "textCompare" && <NgramSimilarities resourceid={eresourceid}/>} */}
            {(displayComponents.includes("nodeCommunities") && windowLoad === "nodeCommunities") && <NodeCommunities resourceid={eresourceid.split("/resource/")[1]} onNodeClick={handleChangeInfo}/>}
            
          </>
          }
        </>
        }
    </div>
  )
}